import { render } from "./SuccessView.vue?vue&type=template&id=0330a780&ts=true"
import script from "./SuccessView.vue?vue&type=script&lang=ts"
export * from "./SuccessView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__